import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service7 from "../../assets/images/service/09.jpg";

import ImgMale from "../../assets/images/service_detail/andrology/01.jpg";
import ImgED from "../../assets/images/service_detail/andrology/02.jpg";
import ImgED2 from "../../assets/images/service_detail/andrology/03.jpg";
import ImgInfertility from "../../assets/images/service_detail/andrology/04.jpg";
import ImgTESE from "../../assets/images/service_detail/andrology/05.jpg";

const Andrology = () => {

const data = {
title:"Andrology (Male Sexual & Fertility Health)",
subtitle:"Advanced male health clinic at BBMH Hospital",

heading:"Best Andrology Specialist",
description:"Andrology focuses on male reproductive and sexual health. At BBMH Hospital Bhilwara, comprehensive diagnosis and advanced treatment for male infertility and sexual health problems are available.",

image:Service7,

sections:[

{
title:"What is Andrology?",
content:"Andrology is a specialized branch of urology that focuses on male reproductive and sexual health. It deals with problems related to male infertility, erectile dysfunction, hormonal imbalance and other male sexual disorders. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced and confidential treatment for male sexual and fertility problems using modern diagnostic and treatment methods.",
image: ImgMale
},

{
title:"Common Andrology Conditions Treated",
content:"Andrology focuses on diagnosis and treatment of male reproductive and sexual health problems that can affect fertility, performance and overall confidence. Early medical consultation helps in identifying the exact cause and providing effective treatment.",
list:[
"Male Infertility – Difficulty in achieving pregnancy due to sperm or hormonal issues.",
"Low Sperm Count (Oligospermia) – Reduced sperm count affecting fertility potential.",
"Erectile Dysfunction (ED) – Inability to achieve or maintain erection during intercourse.",
"Premature Ejaculation – Early ejaculation affecting sexual satisfaction.",
"Retrograde Ejaculation – Semen flows backward into bladder instead of exiting normally.",
"Hormonal Imbalance – Low testosterone or hormonal issues affecting fertility and sexual health.",
"Testicular Problems – Pain, swelling or infection affecting reproductive health.",
"Varicocele – Enlarged veins in scrotum reducing sperm quality.",
"Male Sexual Weakness – Reduced stamina or performance due to physical or psychological causes."
],
image: ImgED
},

{
title:"Symptoms of Male Sexual & Fertility Problems",
content:"Men experiencing the following symptoms should consult an andrology specialist for proper evaluation and treatment:",
list:[
"Difficulty in conceiving despite regular attempts",
"Low sexual desire or reduced libido",
"Difficulty achieving or maintaining erection",
"Early or delayed ejaculation",
"Pain, swelling or heaviness in testicles",
"Low energy, fatigue or weakness",
"Reduced facial or body hair due to hormonal issues"
],
image: ImgED2
},

{
title:"Diagnosis in Andrology",
content:"Accurate diagnosis is essential to identify the root cause of male infertility or sexual health problems. Advanced diagnostic tests help in planning the most effective treatment.",
list:[
"Semen Analysis – To evaluate sperm count, motility and quality.",
"Hormone Profile Tests – To check testosterone and other hormone levels.",
"Ultrasound of Testicles – To detect varicocele or structural problems.",
"Physical Examination – Complete evaluation by specialist.",
"Advanced Fertility Tests – For detailed reproductive health assessment.",
"Genetic Testing – Recommended in selected infertility cases."
],
image: ImgInfertility
},

{
title:"Treatment Options in Andrology",
content:"Treatment depends on the underlying cause and severity of the condition. Modern therapies and procedures help improve fertility and sexual health with high success rates.",
list:[
"Medical therapy to improve sperm count and sexual performance",
"Hormone treatment for testosterone or hormonal imbalance",
"Varicocele surgery to improve sperm quality",
"Lifestyle modification and diet improvement",
"Counselling and stress management for psychological factors",
"Assisted reproductive techniques for infertility",
"Advanced urology procedures for complex cases"
]
},

{
title:"Procedures in Andrology",
content:"Advanced andrology procedures available at BBMH Hospital are performed using modern technology and ensure safe and effective results.",
list:[
"Testicular Biopsy – To evaluate sperm production in infertility cases.",
"TESA – Testicular sperm aspiration for fertility treatment.",
"TESE – Testicular sperm extraction for assisted reproduction.",
"Varicocele Surgery – Microsurgical correction of enlarged veins.",
"Penile Procedures – Advanced treatment for erectile dysfunction."
],
image: ImgTESE
},

{
title:"Benefits of Early Andrology Treatment",
content:"Early diagnosis and treatment of male fertility and sexual health problems significantly improves success rate and overall quality of life.",
list:[
"Improved fertility and conception chances",
"Better sexual performance and confidence",
"Hormonal balance and improved energy",
"Healthy marital and personal life",
"Safe, confidential and effective treatment"
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Andrology Treatment?",
content:"Dr. Sachitanand Chaurasia is an experienced urologist and andrology specialist known for advanced male infertility and sexual health treatment. At BBMH (Brijesh Banger Memorial Hospital), patients receive confidential consultation, modern diagnostic facilities and personalized treatment plans. The focus is on accurate diagnosis, effective therapy and successful outcomes."
}

],

faq:[
{q:"Is male infertility treatable?",a:"Yes many cases treatable."},
{q:"Best test?",a:"Semen analysis."},
{q:"Treatment success?",a:"Depends on cause."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default Andrology;
